import { render, staticRenderFns } from "./HomeSearchGame.vue?vue&type=template&id=404b363c&scoped=true"
import script from "./HomeSearchGame.vue?vue&type=script&lang=js"
export * from "./HomeSearchGame.vue?vue&type=script&lang=js"
import style0 from "./HomeSearchGame.vue?vue&type=style&index=0&id=404b363c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404b363c",
  null
  
)

export default component.exports